module.exports = __webpack_public_path__ + "img/canva_colour_wheel_button.778f2d88.jpg";